import { useMatomo } from '@datapunt/matomo-tracker-react';
import React from 'react';
import { Helmet, HelmetProps } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../providers/Config';

type PageMetaProps = HelmetProps & { children?: React.ReactNode; title: string };

/**
 * This component can be included on a page to set the page title or
 * add any additional meta tags inside <head></head>
 *
 * @param children - The tags to include in the <head></head> element
 * @param title - The HTML document's title
 * @param rest  - Any valid react-helmet props
 */
const PageMeta: React.FC<PageMetaProps> = ({ children, title, ...rest }: PageMetaProps) => {
  //TODO Possibly pass these from the pages and make this component dumber
  const {
    tenantDisplay: {
      logos: { favicon, touch },
    },
  } = useConfig();
  const { trackPageView } = useMatomo();

  const { i18n } = useTranslation();
  const { language } = i18n;

  return (
    <Helmet {...rest} onChangeClientState={trackPageView} htmlAttributes={{ lang: language, 'xml:lang': language }}>
      <link rel="shortcut icon" href={favicon} />
      <link rel="apple-touch-icon" href={touch} />
      <meta name="Content-Language" content={language} />
      <meta httpEquiv="Content-Language" content={language} />
      <title>{title} | AskPorter</title>
      {children}
    </Helmet>
  );
};

export default PageMeta;
